import { type IUseSetPaginationUrlQuery } from '@framework/ui/core/pagination/paginationUrlQuery.ts';
import { type TablePaginationConfig } from 'antd';
import { type SorterResult } from 'antd/es/table/interface';
import { useCallback } from 'react';
import { type AlboRecordBoDTO } from '../backoffice/api/schemas/alboRecordBoDTO.ts';
import { type GetAlboRecordParams as GetAlboRecordParamsBO } from '../backoffice/api/schemas/getAlboRecordParams.ts';
import { type AlboRecordFoDTO } from '../frontoffice/api/schemas/alboRecordFoDTO.ts';
import { type GetAlboRecordParams as GetAlboRecordParamsFO } from '../frontoffice/api/schemas/getAlboRecordParams.ts';

const DEFAULT_PAGE_SIZE = 10;

type AlboRecordDTO = AlboRecordBoDTO | AlboRecordFoDTO;
type GetAlboRecordParams = GetAlboRecordParamsBO | GetAlboRecordParamsFO;

/**
 * Hook per gestire il cambio di pagina e ordinamento nella tabella degli Elenchi.
 */
export function useRegisterRecordsHandleTableChange(
  query: GetAlboRecordParams,
  setQuery: IUseSetPaginationUrlQuery<GetAlboRecordParams>,
) {
  const handleTableChange = useCallback(
    (
      pagination: TablePaginationConfig,
      sorter: SorterResult<AlboRecordDTO> | SorterResult<AlboRecordDTO>[],
    ) => {
      const newQuery: GetAlboRecordParams = {
        ...query,
        pagina: (pagination.current ?? 1) - 1,
        limite: pagination.pageSize ?? DEFAULT_PAGE_SIZE,
      };

      // Gestisce l'ordinamento per colonna singola
      if (!Array.isArray(sorter) && sorter?.order && sorter.columnKey) {
        newQuery.ordinamenti = [
          `${sorter.order === 'ascend' ? '' : '-'}${sorter.columnKey}`,
        ];
      } else {
        // Se l'utente deseleziona l'ordinamento, torna a quello di default o rimuovilo
        newQuery.ordinamenti = [];
      }

      setQuery(newQuery);
    },
    [query, setQuery],
  );

  return {
    handleTableChange,
  };
}
